import { JSX, PropsWithoutRef } from "react";
import { animationDuration } from "../constants";

type AnimateTransformProps = PropsWithoutRef<JSX.IntrinsicElements["animateTransform"]>;

export default function AnimateTransform({ ...props }: AnimateTransformProps) {
  return (
    <animateTransform
      {...props}
      additive="sum"
      attributeName="transform"
      attributeType="xml"
      calcMode="linear"
      dur={animationDuration}
      repeatCount="indefinite"
      type="rotate"
    />
  );
};
